module.exports = __webpack_public_path__ + "img/green-2-oval-solid.3672cf2d.svg";